import React, { useState } from 'react';
import { Login as LoginController, LoginForm, useAuthenticate } from '@ibe/tupvid-components';
import { LoadingOverlay } from '@ibe/components';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import PageUrl from '../Models/PageUrl';

const Login = observer((): JSX.Element => {
  const { persistToken } = useAuthenticate();
  const history = useHistory<string>();
  const originUrl = history.location.state;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const redirectToPage = (): void => {
    let redirectUrl = '';

    if (originUrl) {
      redirectUrl = originUrl;
    } else {
      redirectUrl = PageUrl.HOME;
    }
    history.push(redirectUrl);
  };

  const onSuccess = async (): Promise<void> => {
    setIsLoading(true);
    await persistToken();
    setTimeout(() => {
      setIsLoading(false);
      redirectToPage();
    }, 2000);
  };

  return (
    <LoadingOverlay isLoading={isLoading}>
      <LoginController onSuccess={onSuccess} Form={LoginForm} />
    </LoadingOverlay>
  );
});

export default Login;
